// src/services/analytics.js
import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-ZYGF40GR2G';

// Initialize Google Analytics
export const initGA = () => {
  const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
  console.log('🔑 GA ID from env:', id);
  if (id) {
    ReactGA.initialize(id);
    console.log('✅ Google Analytics initialized');
  } else {
    console.warn('⚠️ Google Analytics ID not found');
  }
};
// Track page views
export const trackPageView = (path) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Track product view
export const trackProductView = (product) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event('view_item', {
    currency: 'INR',
    value: product.price,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      quantity: 1,
    }]
  });
};

// Track add to cart
export const trackAddToCart = (product, quantity) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event('add_to_cart', {
    currency: 'INR',
    value: product.price * quantity,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      quantity: quantity,
    }]
  });
};

// Track checkout started
export const trackBeginCheckout = (cartItems, total) => {
  if (!GA_MEASUREMENT_ID) return;
  const items = cartItems.map(item => ({
    item_id: item.product_id,
    item_name: item.products?.name || 'Product',
    price: item.price || item.products?.price || 0,
    quantity: item.quantity,
  }));
  ReactGA.event('begin_checkout', {
    currency: 'INR',
    value: total,
    items: items,
  });
};

// Track purchase
export const trackPurchase = (orderId, total, items) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event('purchase', {
    transaction_id: orderId,
    currency: 'INR',
    value: total,
    items: items.map(item => ({
      item_id: item.product_id || item.id,
      item_name: item.product_name || item.name,
      price: item.price,
      quantity: item.quantity,
    })),
  });
};

// Track search
export const trackSearch = (query, resultsCount) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event('search', {
    search_term: query,
    results: resultsCount,
  });
};